/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
//import Cart from "cart-store";

// This is how the event is triggered
// This is how you can configure a listener for said event
document.addEventListener('lookfyCartAdded', function(event) {
    // Do your magic :) 

    //const lfCart = cart = Cart.getState().cart;

    //console.log(event.detail);
    //console.log(lfCart);
});


